mtl.alloy.factory['filter-products'] = (function($) {
	'use strict';

	/**
	 * Controller for the mobile product filter
	 */
	return function(element, options) {

		var $element = $(element);

		var $filterMenu = $('.filter');
		var $filterMenuWidth = $filterMenu.width();

		// Show/hide filter/sort menu by filter icon
		$element.unbind('click').click(function() {

			toggleFilterMenu();

		});

		// Hide filter by 'see results' header
		$('.mobile-filter-header').unbind('click').click(function() {

			toggleFilterMenu();

		});

		/**
		 * Toggle filter menu
		 */
		function toggleFilterMenu() {
			// Toggle filter visible class
			$('.filter').toggleClass('filter-visible');

			// Show/hide menu
			if ($filterMenu.hasClass('filter-visible')) {
				$filterMenu.animate({
					right: -20
				});
			} else {
				$filterMenu.animate({
					right: -$filterMenuWidth -60
				}, 250);
			}
		}

		if (app.breakpoint.is('phone-s phone-l')) {
			moveCategoryDescription();
		}

		/**
		 * Move category description for mobile views
		 */
		function moveCategoryDescription() {
			var $categoryDescription = $('.category-description').detach();
			$categoryDescription.appendTo($('.category-container'));
		}

	};

}($));
